import { render, staticRenderFns } from "./ConfigEmailsTable.vue?vue&type=template&id=700afed5"
import script from "./ConfigEmailsTable.vue?vue&type=script&lang=js"
export * from "./ConfigEmailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports